import { LocationApiItem, LocationItem, normalizeLocationSpaceApiItem } from 'types/location'

export function denormalizeLocation(
    location: LocationApiItem
): LocationItem {
    const {
        disabled,
        id,
        name,
        online,
        phone,
        deletedAt: deleted_at,
        imageUrl,
        streetAddress1: street_1,
        streetAddress2: street_2,
        city,
        state,
        country,
        timezone,
        zip,
        locationSpaces,
        manager
    } = location

    return {
        disabled,
        id,
        street_1,
        street_2,
        city,
        zip,
        state,
        country,
        name,
        online: online as boolean,
        phone,
        image_url: imageUrl as unknown as string,
        timezone,
        location_spaces : normalizeLocationSpaceApiItem(locationSpaces),
        manager
    }
}
